'use client';

import type { FC } from 'react';
import Image from 'next/image';

import type { Ingredient } from '@hyex/dxp/types/store/Product/Ingredient';

import TextWithLineBreaks from '@hyex/modules/shared/Inputs/Text';

type PropType = {
  ingredient: Ingredient;
  productName: string;
  onShowModal: () => void;
};

const ProductIngredient: FC<PropType> = ({ ingredient, productName, onShowModal }) => {
  return (
    <>
      <div className="product-ingredient" onClick={onShowModal}>
        <div className="ingredient-img-wrapper">
          {ingredient?.image && (
            <Image
              alt={`Ingredient ${ingredient.name} in ${productName}`}
              src={ingredient.image}
              width={90}
              height={90}
              quality="70"
            />
          )}
        </div>
        <div className="ingredient-text-wrapper" >
          <h4>{TextWithLineBreaks(ingredient.name)}</h4>
          <p>{ingredient.shortDescription}</p>
        </div>
        <div className="more-icon">
          more
        </div>
      </div>
    </>
  );
};

export default ProductIngredient;
